import { buildUmiLocaleMessages } from "./shared";

export default buildUmiLocaleMessages("zh-CN");
